export default "__VITE_ASSET__y9m6$YdO__"